const DATA_FEEDS = 'DATA_FEEDS';

export const DELETE_DATA_FEEDS_REQUEST = `${DATA_FEEDS}/DELETE_DATA_FEEDS_REQUEST`;
export const DELETE_DATA_FEEDS_RESPONSE = `${DATA_FEEDS}/DELETE_DATA_FEEDS_RESPONSE`;
export const DELETE_DATA_FEEDS_ERROR = `${DATA_FEEDS}/DELETE_DATA_FEEDS_ERROR`;

export const FETCH_DATA_FEEDS_REQUEST = `${DATA_FEEDS}/FETCH_DATA_FEEDS_REQUEST`;
export const FETCH_DATA_FEEDS_RESPONSE = `${DATA_FEEDS}/FETCH_DATA_FEEDS_RESPONSE`;
export const FETCH_DATA_FEEDS_ERROR = `${DATA_FEEDS}/FETCH_DATA_FEEDS_ERROR`;

export const UPDATE_DATA_FEEDS_REQUEST = `${DATA_FEEDS}/UPDATE_DATA_FEEDS_REQUEST`;
export const UPDATE_DATA_FEEDS_RESPONSE = `${DATA_FEEDS}/UPDATE_DATA_FEEDS_RESPONSE`;
export const UPDATE_DATA_FEEDS_ERROR = `${DATA_FEEDS}/UPDATE_DATA_FEEDS_ERROR`;

export const CLEAR_DATA_FEEDS_ERROR = `${DATA_FEEDS}/CLEAR_DATA_FEEDS_ERROR`;
